import isotipoImg from "~/assets/academia-isotipo.png";
import { cn } from "~/lib/utils";

/**
 * The real AcademIA seal — the isotipo inside a red ring with a dashed inner
 * border, tilted like a rubber stamp. Used on every certificate surface.
 */
export function AcademiaSeal({ className, size = 64 }: { className?: string; size?: number }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "relative flex items-center justify-center rounded-full bg-landing-red shadow-landing-red",
        "after:absolute after:inset-[9%] after:rounded-full after:border-[1.5px] after:border-dashed after:border-[color-mix(in_srgb,var(--color-white)_60%,transparent)] after:content-['']",
        className,
      )}
      style={{ width: size, height: size }}
    >
      <img
        src={isotipoImg}
        alt=""
        width={Math.round(size * 0.62)}
        height={Math.round(size * 0.62)}
        className="relative object-contain brightness-0 invert"
        style={{ width: Math.round(size * 0.62), height: Math.round(size * 0.62) }}
      />
    </span>
  );
}
